/**
 * Layout and typography constants pixel-measured by ChatGPT from
 * reference product renders (03 Navy Classic).
 * All percentage values are relative to board width (W) or height (H).
 */
export const MAP_ART_LAYOUT = {
  boardAspectRatio: 0.724,
  marginTopPct: 4.63,
  marginBottomPct: 3.97,
  marginLeftPct: 7.13,
  marginRightPct: 6.76,
  mapWidthPct: 86.11,
  mapHeightPct: 78.44,
  gapMapToTextPct: 2.65,

  headlineFontSizePct: 4.5,
  subtitleFontSizePct: 2.2,
  coordsFontSizePct: 1.7,
  headlineToSubtitleGapPct: 0.6,
  subtitleToCoordsGapPct: 0.4,

  typography: {
    headline: {
      fontFamily: '"Cinzel", "Cormorant Garamond", "Trajan Pro", serif',
      fontWeight: 500,
      letterSpacing: "0.04em",
      textTransform: "uppercase" as const,
    },
    subtitle: {
      fontFamily: '"Cormorant Garamond", "Georgia", serif',
      fontWeight: 400,
      letterSpacing: "0.06em",
      textTransform: "capitalize" as const,
    },
    coords: {
      fontFamily: '"Cormorant Garamond", "Georgia", serif',
      fontWeight: 400,
      letterSpacing: "0.03em",
      textTransform: "none" as const,
    },
  },
} as const;

/** Visual effects to replicate the 3D emboss / relief feel */
export const MAP_ART_EFFECTS = {
  mapInsetShadow:
    "inset 0 0 0 1px rgba(0,0,0,0.04), inset 0 -2px 6px rgba(0,0,0,0.06)",
  cardShadow: "0 2px 8px rgba(0,0,0,0.08)",
  bevelLight:
    "inset 1px 1px 0 rgba(255,255,255,0.22)",
  bevelDark:
    "inset -1px -1px 0 rgba(0,0,0,0.12)",
} as const;
